export const getters = {
  isEmpty: state => Object.keys(state.errors).length === 0,
}
